import { jsPDF } from "jspdf";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { loadCustomFontFiraSansLight } from "../assets/fonts/FiraSans-Light-normal"; //base64 de la fuente
import { loadCustomFontFiraSansSemibold } from "../assets/fonts/FiraSans-SemiBold-normal"; //base64 de la fuente
import { loadCustomFontFiraSansRegular } from "../assets/fonts/FiraSans-Regular-normal"; //base64 de la fuente
import { loadB64DB, loadB64Clock, loadB64DBColor, loadB64ClockColor } from "./pdfImgs";
import { formatToSpanishTimeZone } from "./formatDate";

import logoEs from '../assets/myReportin-canal-de-denuncias.png';
import logoCa from '../assets/myreportin_catalan_positivo.png';
import logoEu from '../assets/myreportin_euskera_positivo.png';
import logoGa from '../assets/myreportin_gallego_positivo.png';
import logoEn from '../assets/myreportin_ingles_positivo.png';
import logoIt from '../assets/myreportin_italiano_positivo.png';
import i18n from 'i18next';

const logos = {
  es: logoEs,
  ca: logoCa,
  eu: logoEu,
  ga: logoGa,
  en: logoEn,
  it: logoIt,
};




function addTitleAndTextData(doc, title, text, previousY = 35, companyLogo = false) {
  const titleFontSize = 12;
  const textFontSize = 10;
  const gap = 12;
  const maxWidth = 160; // Define el ancho máximo para el texto
  const pageHeight = 265;

  const color = companyLogo ? 'rgb(169, 169, 169)' : 'rgb(0, 122, 195)';

  // calcular la altura (coordenada Y)
  let newY = previousY !== 0 ? previousY + gap : 20;


  // Verificar si el título va a estar fuera de la página y si es así, añadir una nueva
  if (newY + titleFontSize > pageHeight) {
    doc.addPage();
    addFooter(doc, doc.internal.getNumberOfPages(), companyLogo)
    newY = 20;
  }

  doc.setFontSize(titleFontSize);
  doc.setFont("FiraSans-SemiBold", "normal");

  doc.text(title, 28, newY, { align: 'left' });

  // dibujar linea 

  doc.setDrawColor(color);
  doc.setLineWidth(0.7);
  doc.line(25, newY - 4.5, 25, newY + 1);


  let textY = newY; // Separación entre bloques


  const splitText = doc.splitTextToSize(text, maxWidth);

  for (let i = 0; i < splitText.length; i++) {
    // Verificar si el bloque de texto va a estar fuera de la página y si es así, añadir una nueva
    if (textY > pageHeight) {
      doc.addPage();
      addFooter(doc, doc.internal.getNumberOfPages(), companyLogo)
      textY = 20; // La nueva posición Y para el texto en la nueva página
    }
    doc.setFont("FiraSans-Regular");
    doc.setFontSize(textFontSize);

    textY += i === 0 ? 6 : 5; // primera condición es para el interlineado de la primera a la segunda linea, el segundo es para el resto de lineas

    // Agrega el texto en la posición actual
    doc.text(splitText[i], 28, textY);

  }

  // Calcular la nueva Y para devolver (añadir la altura del bloque de texto)
  const newEndY = textY;

  return newEndY;
}

function addTitleAndTextTimeline(doc, actionNumber, data, previousY = 35, lastItem, companyLogo) {
  const titleFontSize = 12;
  const textFontSize = 10;
  const smallFontSize = 9;
  const gap = 13;
  const maxWidth = 150; // Define el ancho máximo para el texto
  const pageHeight = 265;
  let pageJump = false;
  let pageJumpLineDrawn = false;
  const color = companyLogo ? 'rgb(169, 169, 169)' : 'rgb(0, 122, 195)';


  // calcular la altura (coordenada Y)
  let newY = previousY !== 0 ? previousY + gap : 20;


  // Verificar si el título va a estar fuera de la página y si es así, añadir una nueva
  if (newY + titleFontSize > pageHeight) {
    doc.addPage();
    doc.setLineWidth(0.7);
    pageJump = true;
    addFooter(doc, doc.internal.getNumberOfPages(), companyLogo)
    newY = 20;
  }

  doc.setFontSize(smallFontSize);
  doc.setFont("FiraSans-Light", "normal");
  doc.text(formatToSpanishTimeZone(data.createdAt), 25, newY, { align: 'left' });

  doc.setFontSize(textFontSize);
  doc.setFont("FiraSans-Regular", "normal");
  doc.text(`${i18n.t("incidents:pdfIncident.action")} ` + actionNumber, 40, newY + 6, { align: 'right' });

  doc.setFontSize(titleFontSize);
  doc.setFont("FiraSans-SemiBold", "normal");
  doc.text(data.incidentActivityType, 50, newY, { align: 'left' });

  // dibujar circulo

  doc.setFillColor(color);
  doc.circle(45, newY - 1.5, 2, 'F');


  let textY = newY; // Separación entre bloques

  //GENERAR TEXTO 
  if (data.date) {
    generateActivityText(`-${i18n.t("incidents:pdfIncident.date")}: ${formatToSpanishTimeZone(data.date, true)}`, companyLogo);
  }
  if (data.location) {
    generateActivityText(`-${i18n.t("incidents:pdfIncident.location")}: ${data.location}`, companyLogo);
  }
  if (data.participants) {
    generateActivityText(`-${i18n.t("incidents:pdfIncident.participants")}: ${data.participants}`, companyLogo);
  }
  if (data.description) {
    generateActivityText(`-${i18n.t("incidents:pdfIncident.description")}: ${data.description}`, companyLogo);
  }
  if (data.incidentActivityState) {
    generateActivityText(`-${i18n.t("incidents:pdfIncident.incidentActivityState")}: ${data.incidentActivityState}`, companyLogo);
  }
  if (data.fileName) {
    generateActivityText(`-${i18n.t("incidents:pdfIncident.fileName")}: ${data.fileName}`, companyLogo);
  }


  function generateActivityText(text, companyLogo) {
    const color = companyLogo ? 'rgb(169, 169, 169)' : 'rgb(0, 122, 195)';
    const splitText = doc.splitTextToSize(text, maxWidth);

    for (let i = 0; i < splitText.length; i++) {
      // Verificar si el bloque de texto va a estar fuera de la página y si es así, añadir una nueva
      if (textY > pageHeight) {
        doc.addPage();
        doc.setLineWidth(0.7);
        pageJump = true;
        addFooter(doc, doc.internal.getNumberOfPages(), companyLogo)
        textY = 20; // La nueva posición Y para el texto en la nueva página
      }
      doc.setFont("FiraSans-Regular");
      doc.setFontSize(textFontSize);

      textY += i === 0 ? 6 : 5; // primera condición es para el interlineado de la primera a la segunda linea, el segundo es para el resto de lineas

      // Agrega el texto en la posición actual
      doc.text(splitText[i], 50, textY);


      doc.setDrawColor(color);
      doc.setLineWidth(0.7);
      // Verificar si estamos en la última iteración del bucle y hay salto de página

      if (pageJump) {
        doc.setLineWidth(0.7);
        doc.line(45, 20, 45, textY + gap); // Dibuja la línea desde la parte superior de la nueva página
        pageJump = false; // Restablece el indicador de salto de página
        pageJumpLineDrawn = false;
      } else {
        if (i === splitText.length - 1) {
          // Última línea de texto
          if (lastItem) {
            doc.setLineWidth(0.7);
            doc.setDrawColor(color);
            doc.line(45, newY, 45, textY + 3);
          } else if (!pageJumpLineDrawn) {
            doc.setLineWidth(0.7);
            doc.setDrawColor(color);
            doc.line(45, newY, 45, textY + gap);
          } else {
            doc.setLineWidth(0.7);
            doc.setDrawColor(color);
            doc.line(45, newY, 45, textY + gap);
          }
        } else {
          doc.setLineWidth(0.7);
          doc.setDrawColor(color);
          doc.line(45, newY, 45, textY + 3);
          pageJumpLineDrawn = true;


        }
      }
    }

  }

  // Calcular la nueva Y para devolver (añadir la altura del bloque de texto)
  const newEndY = textY;



  return newEndY;
}



/* FOOTER */
function addFooter(doc, pageNumber, companyLogo) {
  const currentLanguage = i18n.language;

  let logoSIB64 = companyLogo ? companyLogo : logos[currentLanguage] || logoEs;
  const color = companyLogo ? 'rgb(169, 169, 169)' : 'rgb(0, 122, 195)';

  const privacyText = `${i18n.t("incidents:pdfIncident.privacyText1")} \n${i18n.t("incidents:pdfIncident.privacyText2")}`;

  doc.setFontSize(10);
  doc.setFont("FiraSans-Regular");
  doc.setFontSize(18);
  doc.text(`${pageNumber}`, 15, 285, { align: 'left' });
  doc.setDrawColor(color);
  doc.setLineWidth(0.8);
  doc.line(20, 279, 20, 287.5);
  doc.addImage(logoSIB64, "PNG", 24, companyLogo ? 279 : 280, 34, companyLogo ? 8 : 6);

  doc.setFont("FiraSans-Light");
  doc.setFontSize(8);
  doc.text(privacyText, 120, 278 + 5, { align: 'left' });

}

export const downloadIncidentZIP = (data) => {
  const firaSansLightB64 = loadCustomFontFiraSansLight();
  const firaSansSemiboldB64 = loadCustomFontFiraSansSemibold();
  const firaSansRegularB64 = loadCustomFontFiraSansRegular();
  const dbIMG = loadB64DB();
  const clockIMG = loadB64Clock();
  const dbIMGColor = loadB64DBColor();
  const clockIMGColor = loadB64ClockColor();
  const url_splitted = window.location.href.split('/').slice(-2)[0];
  let companyLogo = null;

  if (url_splitted === 'check-incident') {
    companyLogo = `data:${data.companyFileMimeType};base64,${data.companyFileData}`
  }
  
  //DATOS PARA GENERAR EL DOCUMENTO
  const creationDate = data.createdAt;
  const code = data.incidentKey;
  const category = data.category;
  const state = data.state;
  const title = data.title;
  const description = data.description;
  const companyName = data.company;
  const workPlace = data.workPlace;
  const informer = data.userName === null ? `${i18n.t("incidents:pdfIncident.anonymous")}` : data.userName;
  const limitResolutionDate = data.limitDateRes;
  const limitAdmitDate = data.limitDateAd;
  const responsible = data.responsible;
  const fileName = data.fileName;
  const audio = data.audio;
  const incidentActivities = data.incidentActivities;
  const informantType = data.informantType;
  const incidentDate = data.incidentDate;
  const color = companyLogo ? 'rgb(169, 169, 169)' : 'rgb(0, 122, 195)';


  const doc = new jsPDF();


  //AÑADIR FUENTES PERSONALIZADAS
  doc.addFileToVFS('FiraSans-Light-normal.ttf', firaSansLightB64);
  doc.addFileToVFS('FiraSans-SemiBold-normal.ttf', firaSansSemiboldB64);
  doc.addFileToVFS('FiraSans-Regular-normal.ttf', firaSansRegularB64);
  doc.addFont('FiraSans-Light-normal.ttf', 'FiraSans-Light', 'normal');
  doc.addFont('FiraSans-SemiBold-normal.ttf', 'FiraSans-SemiBold', 'normal');
  doc.addFont('FiraSans-Regular-normal.ttf', 'FiraSans-Regular', 'normal');


  // variables del documento
  const dbImg = companyLogo ? dbIMG : dbIMGColor;
  const clockImg = companyLogo ? clockIMG : clockIMGColor;

  const bigFontSize = 17;

  /* Título de datos generales */
  doc.addImage(dbImg, "PNG", 18, 25, 6, 6);
  doc.setFontSize(bigFontSize);
  doc.setFont("FiraSans-SemiBold", "normal");
  doc.text(`${i18n.t("incidents:pdfIncident.generalData")}`, 27, 30, { align: 'left' });
  doc.setDrawColor(color);
  doc.setLineWidth(0.6);
  doc.line(18, 35, 185, 35);
  doc.setFont("FiraSans-Regular");

  addFooter(doc, doc.internal.getNumberOfPages(), companyLogo) //añadir footer a la primera página

  let yCoordinate = 35;
  //CREAR BLOQUES 
  yCoordinate = addTitleAndTextData(doc, `${i18n.t("incidents:pdfIncident.creationDate")}`, formatToSpanishTimeZone(creationDate), yCoordinate, companyLogo);

  yCoordinate = addTitleAndTextData(doc, `${i18n.t("incidents:pdfIncident.code")}`, code, yCoordinate, companyLogo);

  yCoordinate = addTitleAndTextData(doc, `${i18n.t("incidents:pdfIncident.category")}`, category, yCoordinate, companyLogo);

  if (informantType !== '---') {
    yCoordinate = addTitleAndTextData(doc, `${i18n.t("incidents:pdfIncident.informantType")}`, informantType, yCoordinate, companyLogo);
  }

  yCoordinate = addTitleAndTextData(doc, `${i18n.t("incidents:pdfIncident.state")}`, state, yCoordinate, companyLogo);

  yCoordinate = addTitleAndTextData(doc, `${i18n.t("incidents:pdfIncident.title")}`, title, yCoordinate, companyLogo);

  if (incidentDate !== '---') {
    yCoordinate = addTitleAndTextData(doc, `${i18n.t("incidents:pdfIncident.incidentDate")}`, incidentDate, yCoordinate, companyLogo);
  }

  //Preguntas personalizadas
  if (data.customQuestions) {
    data.customQuestions.forEach(questionItem => {
      const question = questionItem.question;
      const response = questionItem.response;
      const combinedText = `${question}: ${response}`;

      // Añadir al PDF
      yCoordinate = addTitleAndTextData(doc, question, response, yCoordinate, companyLogo);
    });
  }

  yCoordinate = addTitleAndTextData(doc, `${i18n.t("incidents:pdfIncident.descriptionIncident")}`, description, yCoordinate, companyLogo);

  yCoordinate = addTitleAndTextData(doc, `${i18n.t("incidents:pdfIncident.companyName")}`, companyName, yCoordinate, companyLogo);

  if (workPlace) {
    yCoordinate = addTitleAndTextData(doc, `${i18n.t("incidents:pdfIncident.workPlace")}`, workPlace, yCoordinate, companyLogo);
  }

  yCoordinate = addTitleAndTextData(doc, `${i18n.t("incidents:pdfIncident.informer")}`, informer, yCoordinate, companyLogo);

  yCoordinate = addTitleAndTextData(doc, `${i18n.t("incidents:pdfIncident.limitResolutionDate")}`, limitResolutionDate, yCoordinate, companyLogo);

  yCoordinate = addTitleAndTextData(doc, `${i18n.t("incidents:pdfIncident.limitAdmitDate")}`, limitAdmitDate, yCoordinate, companyLogo);

  yCoordinate = addTitleAndTextData(doc, `${i18n.t("incidents:pdfIncident.responsible")}`, responsible, yCoordinate, companyLogo);

  if (fileName !== null) {
    yCoordinate = addTitleAndTextData(doc, `${i18n.t("incidents:pdfIncident.fileNameIncident")}`, fileName, yCoordinate, companyLogo);
  }

  if (audio !== null) {
    yCoordinate = addTitleAndTextData(doc, `${i18n.t("incidents:pdfIncident.audioAttachedIncident")}`, `${i18n.t("incidents:pdfIncident.audioAttachedIncidentYes")}`, yCoordinate, companyLogo);
  }


  // Añadir una nueva página
  doc.addPage();
  /* Título de historico del caso */
  doc.addImage(clockImg, "PNG", 18, 25, 6, 6);
  doc.setFontSize(bigFontSize);
  doc.setFont("FiraSans-SemiBold", "normal");
  doc.text(`${i18n.t("incidents:pdfIncident.history")}:`, 27, 30, { align: 'left' });
  doc.setDrawColor(color)
  doc.setLineWidth(0.6);
  doc.line(18, 35, 185, 35);
  doc.setFont("FiraSans-Regular");
  addFooter(doc, doc.internal.getNumberOfPages(), companyLogo)

  if (incidentActivities.length > 1) {

    for (let i = incidentActivities.length - 1; i >= 0; i--) {
      const activityCounter = incidentActivities.length - 1 - i;

      if (i === incidentActivities.length - 1) {
        yCoordinate = addTitleAndTextTimeline(doc, activityCounter + 1, incidentActivities[i], 35, false, companyLogo);

      } else if (i === 0) {
        yCoordinate = addTitleAndTextTimeline(doc, activityCounter + 1, incidentActivities[i], yCoordinate, true, companyLogo);

      } else {
        yCoordinate = addTitleAndTextTimeline(doc, activityCounter + 1, incidentActivities[i], yCoordinate, false, companyLogo);

      }
    }

    addFooter(doc, doc.internal.getNumberOfPages(), companyLogo)

  }


  const pdfName = `${code}.pdf`;


  /* COMPROBARLO CON VIEW PDF COMPONENT */
  /*  const pdfBlob = doc.output("blob");
   const pdfBlobURL = URL.createObjectURL(pdfBlob);
 
   return pdfBlobURL */


  // Convertir el PDF en una representación de bytes
  const pdfBytes = doc.output("arraybuffer");


  // Crear un nuevo objeto ZIP
  const zip = new JSZip();

  // Añadir el PDF al archivo ZIP
  zip.file(pdfName, pdfBytes);

  // Añadir ficehro adjunto en la creación de caso 
  if (data.fileData) {
    const base64Data = data.fileData;

    const additionalFileName = `${data.fileName}`;
    zip.file(additionalFileName, base64Data, { base64: true });
  }

  if (data.audio) {
    const base64Data = data.audio.split(',')[1]; // eliminar "data:audio/mp3;base64,"

    // Nombre del archivo de audio en el ZIP
    const additionalAudioName = `${i18n.t("incidents:pdfIncident.audioAttachedIncidentName")}.mp3`;

    zip.file(additionalAudioName, base64Data, { base64: true });
  }




  // Añadir ficheros de actividades

  if (incidentActivities.length > 1) {

    for (let i = incidentActivities.length - 1; i >= 0; i--) {
      if (incidentActivities[i].fileName) {
        const base64Data = incidentActivities[i].fileData;

        const additionalFileName = `${incidentActivities[i].fileName}`;
        zip.file(additionalFileName, base64Data, { base64: true });
      }
    }
  }


  // Generar el archivo ZIP y desencadenar la descarga
  zip.generateAsync({ type: "blob" }).then((content) => {
    // Usar FileSaver para guardar el ZIP
    saveAs(content, `${code}.zip`);
  });

};

